// Create the "Read More" button
var readMoreButton = document.createElement("button");
readMoreButton.textContent = "Olvass tovább";
readMoreButton.id = "read-more-button";
readMoreButton.className = 'button button--primary button--center tap'

//Content container
var content = document.getElementById("read-more-content");
var container = document.getElementById('read-more-container')

if (container.clientHeight > 200) {

    container.appendChild(readMoreButton);
    content.classList.add("gradient-effect");

    // Add a click event listener to toggle content visibility
    readMoreButton.addEventListener("click", function () {
        content.classList.toggle("expanded");
        if (!container.classList.contains("expanded")) {
            readMoreButton.style.display = "none"; // Hide the button when content is collapsed
        }
    });
}
